import axios from 'axios'
import store from './index'

// Set config defaults when creating the instance
let instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  headers: {
    'Content-Type': 'application/json'
  }
})

let instance2 = axios.create({
  baseURL: process.env.VUE_APP_WORKER_API,
  headers: {
    'Content-Type': 'application/json'
  }
})

// set default if loaded from storage
let accessToken = localStorage.getItem('access_token')

if (accessToken) {
  instance.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
  instance2.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
}

instance.interceptors.request.use(function (config) {
  // Do something before request is sent
  store.dispatch('Setting/serverRequestingAction', true)
  return config
}, function (error) {
  // Do something with request error
  store.dispatch('Setting/serverRequestingAction', false)
  return Promise.reject(error)
})
instance.interceptors.response.use(function (response) {
  // reset server error action
  store.dispatch('Setting/serverErrorAction', '')
  store.dispatch('Setting/serverRequestingAction', false)

  return response
}, function (error) {
  if (error.response.status === 400) {
    let errorMsg = 'Lỗi: '

    try {
      errorMsg = error.response.data.errors
    } catch (e) {

    }

    store.dispatch('Setting/serverErrorAction', errorMsg)
  }
  if (error.response.status === 401) {
    store.dispatch('Auth/authUserLogout')
  }

  store.dispatch('Setting/serverRequestingAction', false)
  return Promise.reject(error)
})

instance2.interceptors.request.use(function (config) {
  // Do something before request is sent
  store.dispatch('Setting/serverRequestingAction', true)
  return config
}, function (error) {
  // Do something with request error
  store.dispatch('Setting/serverRequestingAction', false)
  return Promise.reject(error)
})
instance2.interceptors.response.use(function (response) {
  // reset server error action
  store.dispatch('Setting/serverErrorAction', '')
  store.dispatch('Setting/serverRequestingAction', false)

  return response
}, function (error) {
  if (error.response.status === 400) {
    let errorMsg = 'Lỗi: '

    try {
      errorMsg = error.response.data.errors
    } catch (e) {

    }

    store.dispatch('Setting/serverErrorAction', errorMsg)
  }
  if (error.response.status === 401) {
    store.dispatch('Auth/authUserLogout')
  }

  store.dispatch('Setting/serverRequestingAction', false)
  return Promise.reject(error)
})

export default {
  instance,
  instance2,
  login: async function (username, password) {
    return new Promise((resolve, reject) => {
      instance.post('/v1/auth/login', {
        username: username,
        password: password
      }).then(function (response) {
        // Alter defaults after login process
        instance.defaults.headers.common['Authorization'] = instance.defaults.headers.common['Authorization'] = `Bearer ${response.data.access_token}`
        instance2.defaults.headers.common['Authorization'] = instance.defaults.headers.common['Authorization'] = `Bearer ${response.data.access_token}`

        resolve(response.data)
      }).catch(function (err) {
        reject(err.response.data)
      })
    })
  },
  logout: async function () {
    return new Promise((resolve, reject) => {
      // reset the headers
      instance.defaults.headers.common['Authorization'] = ''
      instance2.defaults.headers.common['Authorization'] = ''
      resolve(true)
    })
  },
  auth: {
    me: function () {
      return new Promise((resolve, reject) => {
        instance.get('/v1/auth/me', {
          params: {}
        }).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    change_username: function (params) {
      return new Promise((resolve, reject) => {
        instance.post('/v1/auth/changeUsername', params).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    change_password: function (params) {
      return new Promise((resolve, reject) => {
        instance.post('/v1/auth/changePassword', params).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    }
  },
  annoucement: {
    list: async function (limit) {
      return new Promise((resolve, reject) => {
        instance.get('/v1/annoucement/list', {
          params: {
            limit: limit
          }
        }).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    }
  },
  customer: {
    list: async function () {
      return new Promise((resolve, reject) => {
        instance.get('/v1/customer/list', {
          params: {}
        }).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    create: async function (params) {
      return new Promise((resolve, reject) => {
        instance.post('/v1/customer/create', params).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    edit: async function (params) {
      return new Promise((resolve, reject) => {
        instance.post('/v1/customer/edit', params).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    delete: async function (id) {
      return new Promise((resolve, reject) => {
        instance.delete(`/v1/customer/remove/${id}`).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    }
  },
  network: {
    list: async function () {
      return new Promise((resolve, reject) => {
        instance.get('/v1/network/list', {
          params: {}
        }).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    }
  },
  formular: {
    listType: async function (params = {}) {
      return new Promise((resolve, reject) => {
        instance.get('/v1/formula/types', {
          params: params
        }).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    list: async function (params = {}) {
      return new Promise((resolve, reject) => {
        instance.get('/v1/formula/list', {
          params: params
        }).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    create: async function (params) {
      return new Promise((resolve, reject) => {
        instance.post('/v1/formula/create', params).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    delete: async function (id) {
      return new Promise((resolve, reject) => {
        instance.delete(`/v1/formula/remove/${id}`).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    loadByAccount: async function (accountId) {
      return new Promise((resolve, reject) => {
        instance.get(`/v1/account/formulas/${accountId}`).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    loadComplexByAccount: async function (accountId) {
      return new Promise((resolve, reject) => {
        instance.get(`/v1/account/complexFormulas/${accountId}`).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    deleteByAccount: async function (id) {
      return new Promise((resolve, reject) => {
        instance.delete(`/v1/account/formula/${id}`).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    deleteComplexByAccount: async function (id) {
      return new Promise((resolve, reject) => {
        instance.delete(`/v1/account/complexFormula/${id}`).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    createNormalLink: async function (params) {
      return new Promise((resolve, reject) => {
        instance.post(`/v1/account/formula`, params).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    createComplexLink: async function (params) {
      return new Promise((resolve, reject) => {
        instance.post(`/v2/account/complexFormula`, params).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    }
  },
  group_formular: {
    list: async function () {
      return new Promise((resolve, reject) => {
        instance.get('/v1/formulaGroup/list', {}).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    listDetail: async function (id) {
      return new Promise((resolve, reject) => {
        instance.get(`/v1/formulaGroup/detail/${id}`, {}).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    addGroup: async function (params) {
      return new Promise((resolve, reject) => {
        instance.post('/v1/formulaGroup/create', params).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    editGroup: async function (params) {
      return new Promise((resolve, reject) => {
        instance.post('/v1/formulaGroup/edit', params).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    deleteGroup: async function (groupId) {
      return new Promise((resolve, reject) => {
        instance.delete(`/v1/formulaGroup/remove/${groupId}`).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    deleteFormulaInGroup: async function (groupId, formulaId) {
      return new Promise((resolve, reject) => {
        instance.delete(`/v1/formulaGroup/removeFormula/${groupId}/${formulaId}`).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    attachFomulaToGroup: async function (groupId, formulaId) {
      return new Promise((resolve, reject) => {
        instance.post(`/v1/formulaGroup/addFormula`, {
          'formula_group_id': groupId,
          'formula_id': formulaId
        }).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    }
  },
  report: {
    list: async function () {
      return new Promise((resolve, reject) => {
        instance.get('/v1/report/list', {
          params: {}
        }).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    detail: async function (reportId) {
      return new Promise((resolve, reject) => {
        instance.get(`/v1/report/detail/${reportId}`, {}).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    saveScanned: async function (fromDate, toDate, data) {
      return new Promise((resolve, reject) => {
        instance.post('/v1/report/save', {
          'from_date': fromDate,
          'to_date': toDate,
          'data': JSON.stringify(data)
        }
        ).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    scan: async function (params) {
      return new Promise((resolve, reject) => {
        instance.post('/v1/scan/mix', params).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    scanMixChild: async function (params) {
      return new Promise((resolve, reject) => {
        instance.post('/v1/scan/mixChild', params).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    scanMixMe: async function (params) {
      return new Promise((resolve, reject) => {
        instance.post('/v1/scan/mixMe', params).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    removeReportDetail: async function (reportId) {
      return new Promise((resolve, reject) => {
        instance.delete(`/v1/report/remove/${reportId}`).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    lockReportDetail: async function (params) {
      return new Promise((resolve, reject) => {
        instance.post('/v1/report/lock', params).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    unlockReportDetail: async function (params) {
      return new Promise((resolve, reject) => {
        instance.put('/v1/report/unlock', params).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    exchangeReportDetail: async function (params) {
      return new Promise((resolve, reject) => {
        instance.post('/v1/report/exchange', params).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    rollbackExchangeReportDetail: async function (params) {
      return new Promise((resolve, reject) => {
        instance.put('/v1/report/exchange-rollback', params).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    }
  },
  account: {
    list: async function (params = {}) {
      return new Promise((resolve, reject) => {
        instance.get('/v1/account/list', {
          params: params
        }).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    listAll: async function (params = {}) {
      return new Promise((resolve, reject) => {
        instance.get('/v1/account/all', {
          params: params
        }).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    create: async function (params) {
      return new Promise((resolve, reject) => {
        instance.post('/v1/account/create', params).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    edit: async function (params) {
      return new Promise((resolve, reject) => {
        instance.post('/v1/account/edit', params).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    delete: async function (id) {
      return new Promise((resolve, reject) => {
        instance.delete(`/v1/account/remove/${id}`).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    accountConfig: async function (flattenAccountArr, flattenTypeArr) {
      return new Promise((resolve, reject) => {
        instance.put('/v1/account/config', {
          'account': flattenAccountArr,
          'type': flattenTypeArr
        }).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    get2FASecret: async function () {
      return new Promise((resolve, reject) => {
        instance.get('/v1/auth/generate2FA').then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    enable2FA: async function (params) {
      return new Promise((resolve, reject) => {
        instance.post('/v1/auth/enable2FA', params).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    disable2FA: async function (params) {
      return new Promise((resolve, reject) => {
        instance.post('/v1/auth/disable2FA', params).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    }
  },
  sub_account: {
    list: async function (params = {}) {
      return new Promise((resolve, reject) => {
        instance.get('/v1/sub/list', {
          params: params
        }).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    detail: async function (id) {
      return new Promise((resolve, reject) => {
        instance.get(`/v1/sub/detail/${id}`, {}).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    create: async function (params) {
      return new Promise((resolve, reject) => {
        instance.post('/v1/sub/create', params).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    lock: async function (id) {
      return new Promise((resolve, reject) => {
        instance.put(`/v1/sub/lock/${id}`, {}, {}).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    active: async function (id) {
      return new Promise((resolve, reject) => {
        instance.put(`/v1/sub/active/${id}`, {}).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    change_password: async function (id, newPassword) {
      return new Promise((resolve, reject) => {
        instance.post('/v1/sub/changePassword', {
          'id': id,
          'password': newPassword
        }).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    }
  },
  transaction: {
    datatables: async function (params = {}) {
      return new Promise((resolve, reject) => {
        instance.get('/v1/transaction/datatables', {
          params: params
        }).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    create: async function (params) {
      return new Promise((resolve, reject) => {
        instance.post('/v1/transaction/create', params).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    editable: async function (params) {
      return new Promise((resolve, reject) => {
        instance.post('/v1/transaction/editable', params).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    delete: async function (id) {
      return new Promise((resolve, reject) => {
        instance.delete(`/v1/transaction/remove/${id}`).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    datatables_usdt_list: async function (params) {
      return new Promise((resolve, reject) => {
        instance.get('/v1/usdt/transactions', {
          params: params
        }).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    withdraw_usdt: async function (params) {
      return new Promise((resolve, reject) => {
        instance.post('/v1/usdt/withdraw', params).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    cancel_withdraw_usdt: async function (params) {
      return new Promise((resolve, reject) => {
        instance.put('/v1/usdt/cancel', params).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    }
  },
  user_activity: {
    list: async function (params = {}) {
      return new Promise((resolve, reject) => {
        instance.get('/v1/auth/activities', {
          params: params
        }).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    }
  },
  package: {
    list: async function () {
      return new Promise((resolve, reject) => {
        instance.get('/v1/package/list', {}).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    },
    buy: async function (packageId) {
      return new Promise((resolve, reject) => {
        instance.post('/v1/package/buy', {
          package_id: packageId
        }).then(function (response) {
          resolve(response.data)
        }).catch(function (err) {
          reject(err.response.data)
        })
      })
    }
  }
}
